import React from 'react';
import ItemContent, { CheckboxContent } from './ItemContent';
import { formatBoolean, formatBooleanToYesNo } from 'components/helper/helper';

interface Props {
  formValues: any;
}

const EthnicitySum = (props: Props) => {
  const [data, setData] = React.useState<any>({
    language: undefined,
    religious_preference: undefined,
    other_religion: undefined,
    us_armed_forces_status: undefined,
    other_religion_language: undefined,
    is_dependent_us_military: '',
    is_consider_hispanic_latino: '',
    is_complete_satisfaction: true,
    number_language_proficient: 1,
    language_array: [],
    is_option_1: false,
    is_option_2: false,
    is_option_3: false,
    is_option_4: false,
    describe_latino_1: false,
    describe_latino_2: false,
    describe_latino_3: false,
    describe_latino_4: false,
    describe_latino_5: false,
    describe_latino_6: false,
    describe_latino_7: false,
    hispanic_latino_1: false,
    hispanic_latino_2: false,
    hispanic_latino_3: false,
    hispanic_latino_4: false,
    hispanic_latino_5: false,
    hispanic_latino_6: false,
    hispanic_latino_7: false,
    racial_background_AsianIndian: false,
    racial_background_Japanese: false,
    racial_background_Filipino: false,
    racial_background_Taiwanese: false,
    racial_background_Bangladeshi: false,
    racial_background_Korean: false,
    racial_background_Hmong: false,
    racial_background_Thai: false,
    racial_background_Chinese: false,
    racial_background_Cambodian: false,
    racial_background_Laotian: false,
    racial_background_Indonesian: false,
    racial_background_Vietnamese: false,
    racial_background_Malaysian: false,
    racial_background_Pakistani: false,
    racial_background_OtherAsian: false,
    racial_background_Afghan: false,
    racial_background_Algerian: false,
    racial_background_Armenian: false,
    racial_background_AssyrianChaldean: false,
    racial_background_Bahraini: false,
    racial_background_Berber: false,
    racial_background_Circassian: false,
    racial_background_Djiboutian: false,
    racial_background_Egyptian: false,
    racial_background_Emirati: false,
    racial_background_Georgian: false,
    racial_background_Iranian: false,
    racial_background_Iraqi: false,
    racial_background_Israeli: false,
    racial_background_Jordanian: false,
    racial_background_Kurdish: false,
    racial_background_Omani: false,
    racial_background_Palestinian: false,
    racial_background_Qatari: false,
    racial_background_SaudiArabian: false,
    racial_background_Somali: false,
    racial_background_Sudanese: false,
    racial_background_Syrian: false,
    racial_background_Tunisian: false,
    racial_background_Turkish: false,
    racial_background_Yemeni: false,
    racial_background_OtherNorthAfrican: false,
    racial_background_OtherSouthwestAsian: false,
    racial_background_African: false,
    racial_background_AfricanAmericanOrBlack: false,
    racial_background_BlackCaribbean: false,
    racial_background_OtherAfrican: false,
    racial_background_AmericanIndian: false,
    racial_background_EuropeanDescent: false,
    racial_background_OtherWhite: false,
    racial_background_more_AfricanAmerican: false,
    racial_background_more_Asian: false,
    racial_background_more_AmericanIndian: false,
    racial_background_more_White: false,
    racial_background_more_NativeHawaiian: false,
    racial_background_white_Europe: false,
    racial_background_white_MiddleEast: false,
    racial_background_white_NorthAfrica: false,
    racial_background_white_Other: false,
    racial_background_identify_AfricanAmerican: false,
    racial_background_identify_NativeHawaiian: false,
    racial_background_identify_White: false,
    racial_background_identify_AmericanIndian: false,
    racial_background_identify_Asian: false,
  });
  React.useEffect(() => {
    if (props.formValues?.all_apply_array) {
      setData({
        ...props.formValues,
        ...JSON.parse(props.formValues.best_option_latino_backgroud_array),
        ...JSON.parse(props.formValues.best_group_describe_racial_background_array),
        ...JSON.parse(props.formValues.best_group_latino_background_array),
      });
    }
  }, [props.formValues]);
  return (
    <>
      {/* {data?.is_consider_hispanic_latino === true && (
        <>
          <ItemContent
            mdCol={12}
            label="Which best describes your Hispanic or Latino background?"
            values={data?.value_consider_hispanic_latino}
          />
          <ItemContent
            hidden={data?.value_consider_hispanic_latino !== 'Other Central American'}
            label={'Please specify Other Central American:'}
            values={data?.specify_is_Other_Central_American}
          />
          <ItemContent
            hidden={data?.value_consider_hispanic_latino !== 'Other South American'}
            label={'Please specify Other South American:'}
            values={data?.specify_is_Other_South_American}
          />
          <ItemContent
            hidden={data?.value_consider_hispanic_latino !== 'Other Hispanic or Latino'}
            label={'Please specify Other Hispanic or Latino:'}
            values={data?.specify_is_Other_Hispanic_or_Latino}
          />
        </>
      )} */}

      {/* Racial Background Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Racial Background</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Regardless of your answer to the prior question, please indicate how you identify
              yourself.
            </div>
            <div className="gm-summary-field-value">
              {[
                {
                  value: 'racial_background_identify_AfricanAmerican',
                  label: 'Black or African American',
                },
                {
                  value: 'racial_background_identify_White',
                  label: 'White',
                },
                {
                  value: 'racial_background_identify_Asian',
                  label: 'Asian',
                },
                {
                  value: 'racial_background_identify_Southwest_Asian_and_North_African',
                  label: 'Southwest Asian and North African',
                },
                {
                  value: 'racial_background_identify_NativeHawaiian',
                  label: 'Native Hawaiian or Other Pacific Islander',
                },
                {
                  value: 'racial_background_identify_AmericanIndian',
                  label: 'American Indian or Alaska Native',
                },
              ].map((option, index) => {
                const keyName = option.value;
                return (
                  <div key={index} style={{ marginBottom: '8px' }}>
                    <CheckboxContent label={option.label} values={data[keyName]} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* American Indian Section */}
      {data?.racial_background_identify_AmericanIndian && (
        <div className="gm-summary-conditional-section">
          <div className="gm-summary-conditional-title">
            American Indian or Alaska Native Information
          </div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Are you an enrolled member of an American Indian or Alaska Native tribe (U.S.)?
              </div>
              <div className="gm-summary-field-value">
                {formatBooleanToYesNo(data?.is_enrolled_member_of_American_Indian_or_Alaska_Native)}
              </div>
            </div>
          </div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Please select the category that best reflects your tribal enrollment. If you are an
                enrolled member of more than one tribe, select your primary tribal affiliation from
                the list of recognized tribes.*
              </div>
              <div className="gm-summary-field-value">
                {data?.tribal_enrollment_category || '-'}
              </div>
            </div>
          </div>

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Please enter the name of the tribe that is your primary affiliation*
              </div>
              <div className="gm-summary-field-value">{data?.tribal_enrollment_primary || '-'}</div>
            </div>
          </div>

          {data?.tribal_enrollment_category === 'Federally recognized tribe' && (
            <>
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Please provide your tribal citizenship or enrollment number.
                  </div>
                  <div className="gm-summary-field-value">
                    {data?.tribal_citizenship_or_enrollment_number || '-'}
                  </div>
                </div>
              </div>

              <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
                Your enrollment in an American Indian or Alaska Native tribe may be considered
                during the comprehensive review of your UC application for admission.
              </div>

              <div className="gm-summary-checkbox-container">
                <div className="gm-summary-text-primary">
                  <span
                    style={{
                      marginRight: '12px',
                      fontSize: '18px',
                      color: formatBoolean(
                        data?.is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information
                      )
                        ? '#1890ff'
                        : '#d9d9d9',
                      fontWeight: formatBoolean(
                        data?.is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information
                      )
                        ? 'bold'
                        : 'normal',
                    }}
                  >
                    {formatBoolean(
                      data?.is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information
                    )
                      ? '✓'
                      : '○'}
                  </span>
                  I consent to the use of my tribal citizenship and enrollment status for purposes
                  concerning my UC application for admission. I understand that this information is
                  subject to verification.
                </div>
                <div style={{ marginTop: '8px' }}>
                  <div className="gm-summary-text-dark">
                    {formatBoolean(
                      data?.is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information
                    )}
                  </div>
                </div>
                {/* <div className="gm-summary-text-primary">
              I consent to the use of my tribal citizenship and enrollment status for purposes concerning my UC application for admission. I understand that this information is subject to verification.
            </div>
            <div style={{ marginTop: '8px' }}>
              <div className="gm-summary-text-dark">
                {data?.is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information ? 'Yes' : 'No'}
              </div>
            </div> */}
              </div>
            </>
          )}

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Please choose the tribe you are enrolled in
              </div>
              <div className="gm-summary-field-value">{data?.csu_tribe_enrolled || '-'}</div>
            </div>
          </div>
        </div>
      )}

      {/* Black or African American Section */}
      {data?.racial_background_identify_AfricanAmerican && (
        <div className="gm-summary-conditional-section">
          <div className="gm-summary-conditional-title">Black or African American Background</div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                What best describes your Black or African American background?
              </div>
              <div className="gm-summary-field-value">{data?.racial_background_African || '-'}</div>
            </div>
          </div>
        </div>
      )}

      {/* Native Hawaiian Section */}
      {data?.racial_background_identify_NativeHawaiian && (
        <div className="gm-summary-conditional-section">
          <div className="gm-summary-conditional-title">
            Native Hawaiian or Other Pacific Islander Background
          </div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Which best describes your Native Hawaiian or Other Pacific Islander background?*
              </div>
              <div className="gm-summary-field-value">
                {data?.value_is_Native_Hawaiian_or_Other_Pacific_Islander || '-'}
              </div>
            </div>
          </div>

          {data?.value_is_Native_Hawaiian_or_Other_Pacific_Islander?.includes('Other') && (
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Please specify Other Pacific Islander:*
                </div>
                <div className="gm-summary-field-value">
                  {data?.racial_OtherPacific_value || '-'}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* White Section */}
      {data?.racial_background_identify_White && (
        <div className="gm-summary-conditional-section">
          <div className="gm-summary-conditional-title">White Background</div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Which best describes your White background?
              </div>
              <div className="gm-summary-field-value">
                {data?.racial_background_White === 'Other White'
                  ? `Other White, ${data?.racial_OtherWhite_value}`
                  : data?.racial_background_White || '-'}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Asian Section */}
      {data?.racial_background_identify_Asian && (
        <div className="gm-summary-conditional-section my-16">
          <div className="gm-summary-conditional-title">Asian Background</div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Which best describes your Asian background?
              </div>
              <div className="gm-summary-field-value">{data?.value_is_Asian || '-'}</div>
            </div>
          </div>
        </div>
      )}

      {data?.value_is_Asian === 'Other' && (
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Please specify Other Asian:*</div>
            <div className="gm-summary-field-value">{data?.racial_OtherAsian_value || '-'}</div>
          </div>
        </div>
      )}
      {/* Southwest Asian and North African Section */}
      {data?.racial_background_identify_Southwest_Asian_and_North_African && (
        <div className="gm-summary-conditional-section my-16">
          <div className="gm-summary-conditional-title">
            Southwest Asian and North African Background
          </div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                Which best describes your Southwest Asian or North African background?
              </div>
              <div className="gm-summary-field-value">
                {data?.racial_Southwest_Asian_and_North_African || '-'}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CSU Reporting Preferences Section */}
      <div className="gm-summary-section my-16">
        <div className="gm-summary-section-title">CSU Reporting Preferences</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              California State University often needs to report ONLY ONE summary race/ethnicity
              description for a person. Please select your reporting preferences:
            </div>
            <div className="gm-summary-field-value">{data?.csu_reporting_preferences || '-'}</div>
          </div>
        </div>
      </div>

      {/* Completion Section */}
      <div className="gm-summary-section my-16">
        <div className="gm-summary-checkbox-container">
          <div className="gm-summary-text-primary">
            <span
              style={{
                marginRight: '12px',
                fontSize: '18px',
                color: formatBoolean(data?.is_complete_satisfaction) ? '#1890ff' : '#d9d9d9',
                fontWeight: formatBoolean(data?.is_complete_satisfaction) ? 'bold' : 'normal',
              }}
            >
              {formatBoolean(data?.is_complete_satisfaction) ? '✓' : '○'}
            </span>
            Yes, I have completed this section to my satisfaction.
          </div>
        </div>
      </div>
    </>
  );
};

export default EthnicitySum;
